<span *ngIf="count" class="notification-counter">{{count}}</span>